import { EObjectType, IJsonQuery } from './types';

export const isOnlyLandTypeSelected = (jsonQuery: IJsonQuery) => {
  const selectedOfferTypes = jsonQuery.object_type?.value;

  return selectedOfferTypes?.length === 1 && selectedOfferTypes[0] === EObjectType.Land;
};
